var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-loader"},[_c('div',{staticClass:"full-loader__overlay"}),_c('div',{staticClass:"full-loader__info"},[_c('logo',{attrs:{"centered":true}}),_c('div',{staticClass:"full-loader__text"},[_vm._v("\n      Загрузка системы...\n    ")]),_c('div',{staticClass:"full-loader__spinner"},[_c('spin',{attrs:{"size":"large"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }